export type AccessListItem = {
  type: string;
  label: string;
  orgId: number;
  termsAccepted: boolean;
  isOrgAdmin: boolean;
  isBillingUser: boolean;
};

export type BamxPerms = {
  admin: boolean;
};

export type Organization = {
  orgId?: number | null;
  type?: string | null;
  pub_id?: number | null;
  merch_id?: number | null;
  publisher_type?: string | null;
  isOrgAdmin?: boolean | null;
  termsAccepted?: boolean | null;
};

type State = {
  reported: boolean;
  isLoggedIn: boolean;
  jwt: string | null;
  currentUser: null;
  isAdmin: boolean;
  accessList: AccessListItem[];
};

export const state: State = {
  reported: false,
  jwt: null,
  currentUser: null,
  isAdmin: false,
  accessList: [],
  get isLoggedIn() {
    // return !!(this.jwt && this.currentUser); // TODO: move current user into here from session
    return !!this.jwt;
  },
};
